export const routes = {
  LOGIN: '/',
  DASHBOARD: "/dashboard",
  MANAGEPAGE: "/manage",
  PROFILE: "/profile",
  SENDPAGE: "/send",
  NOT_FOUND: '/404',
  PARKING_ORBIT: "/parking-orbit",
  INACTIVE_USER: "/inactive",
};

